import { BillingAddOnsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/billing/add-ons')({
  component: BillingAddOnsRoute,
});
